import { useState, useContext } from "react";
import { Link } from "react-router";
import { WalletContext } from "../../layout/WalletContext";

const Header = () => {
  const { walletAddress, disconnectWallet, connectWallet } =
    useContext(WalletContext);

  const [loading, setLoading] = useState(false);

  return (
    <header className="bg-white/70 dark:bg-slate-900 backdrop-blur-md shadow-2xl border-b border-emerald-100 dark:border-slate-700 px-8 py-4">
      <div className="flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center gap-8">
          <h1 className="text-2xl font-bold bg-gradient-to-r from-emerald-500 to-cyan-500 bg-clip-text text-transparent">
            Flash Loan Bot
          </h1>
        </div>

        {/* Wallet Controls */}
        <div className="flex items-center gap-4">
          {walletAddress && (
            <div className="hidden md:block">
              <div className="flex items-center gap-2 bg-emerald-50 dark:bg-slate-800 px-3 py-2 rounded-full border border-emerald-200 dark:border-slate-600">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-xs text-emerald-700 dark:text-emerald-300 font-medium">
                  {`${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`}
                </span>
              </div>
            </div>
          )}

          <button
            onClick={walletAddress ? disconnectWallet : connectWallet}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
              walletAddress
                ? "bg-white dark:bg-slate-800 border border-emerald-200 dark:border-slate-600 text-emerald-600 dark:text-emerald-300 hover:shadow-md hover:scale-105"
                : "bg-gradient-to-r from-emerald-500 to-cyan-500 text-white hover:shadow-md hover:scale-105"
            }`}
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center gap-2">
                <svg
                  className="animate-spin h-4 w-4 text-current"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>Connecting...</span>
              </span>
            ) : walletAddress ? (
              "Disconnect"
            ) : (
              "Connect Wallet"
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
